import type { ProductSortingSchema } from '@coas/validators/const';

export const sortingItems = [
    { key: null, title: 'По умолчанию' },
    { key: 'expensive-first', title: 'Сначала дорогие' },
    { key: 'cheap-first', title: 'Сначала дешевые' },
    { key: 'new-first', title: 'Сначала новые' },
    { key: 'old-first', title: 'Сначала старые' },
] satisfies Array<{
    key: ProductSortingSchema;
    title: string;
}>;
